import gql from 'graphql-tag';

import multiUnitListWrapperFragments from '../MultiUnitListWrapper/MultiUnitListWrapper.fragments';

const multiUnitDropdownFragments = {
    Listing: gql`
        fragment MultiUnitDropdownListing on Listing {
            ...MultiUnitListWrapperListing
        }
        ${multiUnitListWrapperFragments.Listing}
    `
};

export default multiUnitDropdownFragments;
